// AUTO-GENERATED — do not edit by hand.
//
// The canonical ids of every MCPJam-hosted model, emitted by
// scripts/generate-hosted-model-ids.mjs from the backend's public catalog
// (`GET /v1/models`). This snapshot is the offline/cold-start FLOOR for the
// server billing catalog cache and the client picker fallback, so a cold
// start during a backend-catalog outage still classifies hosted models as
// source:"mcpjam" instead of silently mis-billing as BYOK. The live catalog
// fetch is authoritative at runtime; regenerate this after a backend deploy
// widens the catalog.

export const HOSTED_MODEL_IDS = [
  "amazon/nova-2-lite",
  "amazon/nova-lite",
  "amazon/nova-micro",
  "amazon/nova-pro",
  "anthropic/claude-fable-5",
  "anthropic/claude-haiku-4.5",
  "anthropic/claude-opus-4",
  "anthropic/claude-opus-4.1",
  "anthropic/claude-opus-4.5",
  "anthropic/claude-opus-4.6",
  "anthropic/claude-opus-4.6-fast",
  "anthropic/claude-opus-4.7",
  "anthropic/claude-opus-4.8",
  "anthropic/claude-sonnet-4",
  "anthropic/claude-sonnet-4.5",
  "anthropic/claude-sonnet-4.6",
  "anthropic/claude-sonnet-5",
  "arcee-ai/trinity-large-thinking",
  "arcee-ai/trinity-mini",
  "bytedance/seed-1.6",
  "bytedance/seed-1.8",
  "cohere/command-a",
  "deepseek/deepseek-v3",
  "deepseek/deepseek-v3.2",
  "deepseek/deepseek-v3.2-thinking",
  "deepseek/deepseek-v4-flash",
  "deepseek/deepseek-v4-pro",
  "google/gemini-2.5-flash",
  "google/gemini-2.5-flash-lite",
  "google/gemini-2.5-pro",
  "google/gemini-3-flash",
  "google/gemini-3-flash-preview",
  "google/gemini-3.1-flash-lite",
  "google/gemini-3.1-flash-lite-preview",
  "google/gemini-3.1-pro-preview",
  "google/gemini-3.5-flash",
  "google/gemma-4-26b-a4b-it",
  "google/gemma-4-31b-it",
  "inception/mercury-2",
  "inception/mercury-coder-small",
  "kwaipilot/kat-coder-air-v2.5",
  "kwaipilot/kat-coder-pro-v1",
  "kwaipilot/kat-coder-pro-v2",
  "kwaipilot/kat-coder-pro-v2.5",
  "meta-llama/llama-4-maverick",
  "meta-llama/llama-4-scout",
  "meta-llama/muse-spark-1.1",
  "minimax/minimax-m2",
  "minimax/minimax-m2.1",
  "minimax/minimax-m2.1-lightning",
  "minimax/minimax-m2.5",
  "minimax/minimax-m2.5-highspeed",
  "minimax/minimax-m2.7",
  "minimax/minimax-m2.7-highspeed",
  "minimax/minimax-m3",
  "mistralai/devstral-2",
  "mistralai/devstral-2512",
  "mistralai/devstral-small-2",
  "mistralai/magistral-medium",
  "mistralai/magistral-small",
  "mistralai/ministral-14b",
  "mistralai/ministral-3b",
  "mistralai/ministral-8b",
  "mistralai/mistral-large-2512",
  "mistralai/mistral-large-3",
  "mistralai/mistral-medium",
  "mistralai/mistral-medium-3-5",
  "mistralai/mistral-medium-3.5",
  "mistralai/mistral-small",
  "mistralai/mistral-small-2603",
  "moonshotai/kimi-k2",
  "moonshotai/kimi-k2-0905",
  "moonshotai/kimi-k2-thinking",
  "moonshotai/kimi-k2.5",
  "moonshotai/kimi-k2.6",
  "moonshotai/kimi-k2.7-code",
  "moonshotai/kimi-k2.7-code-highspeed",
  "nvidia/nemotron-3-nano-30b-a3b",
  "nvidia/nemotron-3-super-120b-a12b",
  "nvidia/nemotron-3-ultra-550b-a55b",
  "nvidia/nemotron-nano-12b-v2-vl",
  "nvidia/nemotron-nano-9b-v2",
  "openai/gpt-4.1",
  "openai/gpt-4.1-mini",
  "openai/gpt-4.1-nano",
  "openai/gpt-4o",
  "openai/gpt-4o-mini",
  "openai/gpt-5",
  "openai/gpt-5-chat",
  "openai/gpt-5-codex",
  "openai/gpt-5-mini",
  "openai/gpt-5-nano",
  "openai/gpt-5-pro",
  "openai/gpt-5.1-codex",
  "openai/gpt-5.1-codex-max",
  "openai/gpt-5.1-codex-mini",
  "openai/gpt-5.1-instant",
  "openai/gpt-5.1-thinking",
  "openai/gpt-5.2",
  "openai/gpt-5.2-chat",
  "openai/gpt-5.2-codex",
  "openai/gpt-5.2-pro",
  "openai/gpt-5.3-chat",
  "openai/gpt-5.3-codex",
  "openai/gpt-5.4",
  "openai/gpt-5.4-mini",
  "openai/gpt-5.4-nano",
  "openai/gpt-5.4-pro",
  "openai/gpt-5.5",
  "openai/gpt-5.5-pro",
  "openai/gpt-5.6-luna",
  "openai/gpt-5.6-sol",
  "openai/gpt-5.6-terra",
  "openai/gpt-oss-120b",
  "openai/gpt-oss-20b",
  "openai/gpt-oss-safeguard-20b",
  "openai/o3",
  "openai/o3-deep-research",
  "openai/o3-pro",
  "openai/o4-mini",
  "qwen/qwen-3-14b",
  "qwen/qwen-3-235b",
  "qwen/qwen-3-30b",
  "qwen/qwen-3-32b",
  "qwen/qwen3-235b-a22b-thinking",
  "qwen/qwen3-coder",
  "qwen/qwen3-coder-30b-a3b",
  "qwen/qwen3-coder-next",
  "qwen/qwen3-coder-plus",
  "qwen/qwen3-max",
  "qwen/qwen3-max-thinking",
  "qwen/qwen3-next-80b-a3b-instruct",
  "qwen/qwen3-next-80b-a3b-thinking",
  "qwen/qwen3-vl-235b-a22b-instruct",
  "qwen/qwen3-vl-instruct",
  "qwen/qwen3-vl-thinking",
  "qwen/qwen3.5-122b-a10b",
  "qwen/qwen3.5-27b",
  "qwen/qwen3.5-35b-a3b",
  "qwen/qwen3.5-9b",
  "qwen/qwen3.5-flash",
  "qwen/qwen3.5-flash-02-23",
  "qwen/qwen3.5-plus",
  "qwen/qwen3.6-27b",
  "qwen/qwen3.6-plus",
  "qwen/qwen3.7-max",
  "qwen/qwen3.7-plus",
  "sakana/fugu-ultra",
  "stepfun/step-3.5-flash",
  "stepfun/step-3.7-flash",
  "x-ai/grok-4-fast",
  "x-ai/grok-4.1-fast",
  "x-ai/grok-4.20",
  "x-ai/grok-4.3",
  "x-ai/grok-4.5",
  "x-ai/grok-build-0.1",
  "x-ai/grok-code-fast-1",
  "xiaomi/mimo-v2.5",
  "xiaomi/mimo-v2.5-pro",
  "z-ai/glm-4.5",
  "z-ai/glm-4.5-air",
  "z-ai/glm-4.5v",
  "z-ai/glm-4.6",
  "z-ai/glm-4.6v",
  "z-ai/glm-4.7",
  "z-ai/glm-4.7-flash",
  "z-ai/glm-4.7-flashx",
  "z-ai/glm-5",
  "z-ai/glm-5-turbo",
  "z-ai/glm-5.1",
  "z-ai/glm-5.2",
  "z-ai/glm-5.2-fast",
  "z-ai/glm-5v-turbo",
] as const;
